import { TefComs4cs4p } from '@mfe/components/TefComs4cs4p';
import { html } from 'lit';

// This is just for testing
export const forTesting = function render(this: TefComs4cs4p) : ReturnType<typeof html> {
  return html`<p>${this.loadedResourcesCount}</p>`;
};
